import { useKeycloak } from '@react-keycloak/web'
import { useSelector } from 'react-redux'
import { getRoleName } from '../enums/enumUserRoles'
import { useAppDispatch } from '../redux/store'
import { loadUserAction, logOutAction } from '../redux/user/actions'
import {
  selectUserHasFullAccess,
  selectUserIsLoged,
  selectUserLoading,
  selectUserName,
  selectUserNameFull,
  selectUserRoles,
  selectUserSubjectData,
} from '../redux/user/selectors'

export const useUser = () => {
  const dispatch = useAppDispatch()
  const { keycloak, initialized } = useKeycloak()
  const userIsLoged = useSelector(selectUserIsLoged) && keycloak.authenticated
  const userLoading = useSelector(selectUserLoading) || !initialized
  const username = useSelector(selectUserName)
  const usernameFull = useSelector(selectUserNameFull)
  const hasFullAccess = useSelector(selectUserHasFullAccess)
  const isAdmin = keycloak.realm === process.env.REACT_APP_KEYCLOAK_REALM_ADMIN && userIsLoged
  const userSubjectData = useSelector(selectUserSubjectData)

  const roles = useSelector(selectUserRoles)
  const orgName = userSubjectData?.nazev ?? ''
  const roleName = getRoleName(roles)

  const loadUser = () => {
    dispatch(loadUserAction(keycloak))
  }

  const login = () => {
    keycloak.login()
  }

  const logout = () => {
    dispatch(logOutAction(keycloak))
  }

  return {
    initialized,
    username,
    usernameFull,
    userLoading,
    userIsLoged,
    login,
    logout,
    loadUser,
    hasFullAccess,
    isAdmin,
    orgName,
    roleName,
  }
}
